<script setup>
import VInputReadonlyWithLabel from "../../Form/VInputReadonlyWithLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    survey_location: answers?.survey_location,
    nationality: answers?.nationality,
    country_of_residence: answers?.country_of_residence,
    gender: answers?.gender,
    marital_status: answers?.marital_status,
    age: answers?.age,
    current_employment: answers?.current_employment,
});
</script>

<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="survey_location"
                        v-model:value="form.survey_location"
                        :label="surveyFields['survey_location']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="nationality"
                        v-model:value="form.nationality"
                        :label="surveyFields['nationality']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="country_of_residence"
                        v-model:value="form.country_of_residence"
                        :label="surveyFields['country_of_residence']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="gender"
                        v-model:value="form.gender"
                        :label="surveyFields['gender']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="marital_status"
                        v-model:value="form.marital_status"
                        :label="surveyFields['marital_status']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="age"
                        v-model:value="form.age"
                        :label="surveyFields['age']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="current_employment"
                        v-model:value="form.current_employment"
                        :label="surveyFields['current_employment']?.name"
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
